// extracted by mini-css-extract-plugin
export var addressFields = "_mb-0";
export var animationContainer = "_mb-1";
export var footer = "_mb-2";
export var lineItems = "_mb-3";
export var modalContent = "_mb-4";
export var orderName = "_mb-5";
export var strong = "_mb-6";
export var warning = "_mb-7";